import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import Tooltip from '../widget/Tooltip';
import Exchange from '../../models/Exchange';
import User from '../../models/User';
import { NumberFormatter } from '../../utils/Intl';

export default class GuestpointsRow extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    constructor(props) {
        super(props);

        this.isGuest = this.isGuest.bind(this);
        this.renderGuestpoints = this.renderGuestpoints.bind(this);
        this.renderGuestpointsEarned = this.renderGuestpointsEarned.bind(this);
        this.renderTotal = this.renderTotal.bind(this);
    }

    isGuest() {
        const guest = this.props.exchange.get('guest');
        return guest && guest.id == this.props.user.id;
    }

    render() {
        return (
            <div className="form-group editable-field guestpoint_amount">
                <label>{i18n.t('exchange:guestpoints')}</label>
                {this.renderGuestpoints()}
                {this.renderGuestpointsEarned()}
            </div>
        );
    }

    renderGuestpoints() {
        const detail = i18n.t('common:value_per_night', {
            value: `${NumberFormatter.format(this.props.exchange.get('guestpoint_amount'))} GP`,
            nb_night: NumberFormatter.format(this.props.exchange.getNightNb())
        });
        return (
            <span className="value">
                {detail} {this.renderTotal()}
            </span>
        );
    }

    renderTotal() {
        const sign = this.props.exchange.getGpTotal() == 0 ? '' : this.isGuest() ? '-' : '+';
        return (
            <span className="pull-right">
                {sign}
                {NumberFormatter.format(this.props.exchange.getGpTotal())} GP
            </span>
        );
    }

    renderGuestpointsEarned() {
        const gpEarned = this.props.conversation.getGPEarned();
        if (this.isGuest() && gpEarned && this.props.conversation.isMutual()) {
            return (
                <div className="extra">
                    <label>
                        {i18n.t('exchange:gp_earned')}
                        <Tooltip
                            title={i18n.t('exchange:gp_given_by', {
                                first_name: this.props.exchange.get('host').get('first_name')
                            })}
                        />
                    </label>
                    <span className="value">+{NumberFormatter.format(gpEarned)} GP</span>
                </div>
            );
        }
    }
}
